import React from 'react'
import ScrollToTop from '../components/ScrollToTop'
import { Helmet } from 'react-helmet';


function DeliveryPolicy() {
    return (
        <>
            <ScrollToTop />

            <Helmet>
                <title>Политика за достава | Моторни масла и авто делови</title>
                <meta name="description" content="Дознајте повеќе за нашата политика за достава – рокови, цена и начин на испорака низ Македонија." />
                <meta name="keywords" content="достава, политика за достава, испорака, рокови за испорака, цена за достава, онлајн продавница, моторни масла, авто делови" />
            </Helmet>

            <div className='w-full flex justify-center py-16 bg-gray-50 mt-6 '>
                <div className='mx-auto max-w-[800px] px-6 '>
                    <h1 className='text-4xl font-semibold text-center'>Политика за достава</h1>
                    <p className='text-l mt-6  leading-relaxed'>
                        Производите достапни на malservis.mk се испорачуваат само на територијата на Република Македонија. Плаќањето на производите се врши исклучиво во денари.
                    </p>
                    <p className='text-l mt-6  leading-relaxed'>
                        malservis.mk нуди бесплатна испорака за сите пратки над 1800 ден. на територијата на Скопје,  и над 3500 ден. во останатите градови и населени места низ Република Македонија.
                    </p>
                    <p className='text-l mt-6  leading-relaxed'>
                        Доставата за нарачки со сума пониска од горенаведените е фиксна и изнесува 130 денари за Скопје и 180 денари за останатите градови и населени места низ Република Македонија.
                    </p>
                    <p className='text-l mt-6  leading-relaxed'>
                        Испораките се вршат преку карго служба во рок од 1 до 3 работни денови од нарачката, но во некои исклучителни ситуации и до 5 работни денови. Доставата се врши до влезот на станбениот објект од наведената адреса. Во недела и на неработни денови не се врши испорака на пратки.
                    </p>
                    <p className='text-l mt-6  leading-relaxed'>
                        Начин на плаќање:
                        <ul className='list-inside list-disc'>
                            <li>
                                При испорака со откуп од курирот
                            </li>
                        </ul>
                    </p>
                    <p className='text-l mt-6  leading-relaxed'>
                        Сите нарачки направени во петок после 16 часот или за време на викенд ќе бидаат процесирани во првиот следен работен ден.
                    </p>
                    <p className='text-l mt-6  leading-relaxed'>
                        Курирот пратката ја доставува на адресата за испорака во период од 8 до 16 часот. Во Скопје времето на достава може да варира (по претходен договор со Вас). Ве молиме во тој период да обезбедите лице на соодветната адреса за прием на пратката. Доколку курирот не Ве пронајде на адресата, вообичаена пракса е да Ве побара на телефонскиот број кој сте го пишале при креирање на нарачката со цел да договорите нов термин за достава. Доколку и во вториот обид за достава не Ве најде на договорената адреса, пратката ќе ни ја врати нам. По прием на пратката, ќе Ве контактираме за да ги утврдиме причините за неизвршувањето на доставата и ќе договориме повторна достава.
                    </p>
                </div>
            </div>
        </>
    )
}

export default DeliveryPolicy
